"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.QuestionLabelHolder = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["children"];
var Container = _styledComponents["default"].div.withConfig({
  displayName: "radioCheckboxLabelHolder__Container"
})(["display:flex;justify-content:space-evenly;width:100%;align-items:center;justify-content:", ";& p{font-size:1rem;line-height:1.2;margin-block:0px !important;padding-top:", ";}@media only screen and (max-width:760px),(min-device-width:768px) and (max-device-width:1024px){margin:", ";}margin:", ";"], function (props) {
  return props.displayRow ? 'center' : '';
}, function (props) {
  return props.displayRow ? 0 : '2px';
}, function (props) {
  return props.displayRow ? "5px 0" : "10px 0";
}, function (props) {
  return props.displayRow ? "0" : "10px 0";
});
var _default = exports["default"] = function _default(_ref) {
  var children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Container, (0, _extends2["default"])({
    className: "radiocheckboxlabelholder"
  }, props), children, /*#__PURE__*/_react["default"].createElement(_formElements.AccessibleInputLabel, (0, _extends2["default"])({
    className: props.displayLabel ? null : 'responsive-input-label'
  }, props, {
    label: "".concat(props.label)
  })));
};
var QuestionLabelHolder = exports.QuestionLabelHolder = _styledComponents["default"].div.withConfig({
  displayName: "radioCheckboxLabelHolder__QuestionLabelHolder"
})(["margin-bottom:15px;p{margin-bottom:0;}"]);